/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var normalizeComponent = require('../../normalize-component-d885d5ff.js');

//
//
//
//
//
//
//
//
//
//

var script = {
  name: "MqButton",
  data: function data() {
    return {};
  },
  props: {
    type: {
      type: String,
      default: "green"
    },
    customStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    size: {
      type: String,
      default: "medium"
    },
    status: {
      type: String,
      default: "pointer"
    },
    text: {
      type: String,
      default: ""
    }
  },
  methods: {
    triggerEvent: function triggerEvent() {}
  }
};

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "mq_button rounded-8px",
      class: [
        _vm.type,
        _vm.size !== "self"
          ? _vm.size
          : _vm.$mq.web
          ? "medium text-style-body-400"
          : _vm.$mq.pd
          ? "small text-style-medium-400"
          : "mini text-style-medium-400",
        _vm.status,
      ],
      style: _vm.customStyle,
      on: {
        click: function ($event) {
          _vm.status !== "not" && _vm.$emit("click", $event);
        },
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.text) + "\n")]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-e0d02156";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__.install = function (Vue) {
  Vue.component(__vue_component__.name, __vue_component__);
};

module.exports = __vue_component__;
